"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressCircle = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ProgressCircle = exports.ProgressCircle = function ProgressCircle(_ref) {
  var Component = _ref.Component,
    styles = _ref.styles;
  return /*#__PURE__*/_react["default"].createElement(Component, {
    className: styles.progressCircle
  });
};
ProgressCircle.defaultProps = {
  Component: 'div',
  styles: {}
};
ProgressCircle.propTypes = {
  Component: _propTypes["default"].node,
  styles: _propTypes["default"].objectOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]))
};